/**
 * Shared low-level helpers for the BarChart "hidden datapoints" feature.
 *
 * Hidden datapoints can be stored in two shapes:
 *   - new format: { display: string, value: string }
 *   - legacy format: plain string
 *
 * Higher-level resolution (preset → effective hidden list) lives in
 * ../../utils/visibilityState.js as `resolveHidden`.
 */

export const normalizeDisplayValue = (displayVal) => {
  if (Array.isArray(displayVal)) return displayVal[0] || "";
  return displayVal || "";
};

export const normalizeValue = (val) => {
  if (val === null || val === undefined) return "";
  if (Array.isArray(val)) return val[0] != null ? String(val[0]) : "";
  if (typeof val === "object") return JSON.stringify(val);
  return String(val);
};

/** Identifier extractor — supports both {display,value} and legacy string. */
export const getHiddenItemValue = (item) => {
  if (typeof item === "object" && item !== null) return item.value || "";
  return String(item || "");
};

/** Display extractor — supports both {display,value} and legacy string. */
export const getHiddenItemDisplay = (item) => {
  if (typeof item === "object" && item !== null) return item.display || "";
  return String(item || "");
};
